<template>
    <section class="pb-12 bg-white lg:pb-16 lg:px-8">
        <div class="px-4 mx-auto max-w-screen-xl sm:px-6 lg:px-8">
            <div class="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-0">
                <!-- Left Column -->
                <div class="lg:pr-8 lg:border-r lg:border-[#CECECE]">
                    <h3 class="mb-8 font-bold text-center text-black md:mb-12 font-ww-bold lg:text-left"
                        :class="newStyle ? 'text-4xl' : 'xl:text-3xl text-2xl'" v-html="leftTitle">
                    </h3>
                    <div class="space-y-12">
                        <div v-for="(item, index) in leftItems" :key="index"
                            class="flex relative lg:!items-end gap-y-8 md-max:items-center" :class="[
                                item.layout === 'image-left' ? 'flex-row-reverse' : '',
                                item.align ? `items-${item.align}` : 'items-center',
                                newStyle ? '' : 'md-max:flex-col',
                            ]">
                            <!-- Text Box -->
                            <div class="relative z-10 p-6 text-white rounded-2xl shadow-lg "
                                :class="[item.textBoxWidth || 'w-[65%]', item.textBoxClass, newStyle ? 'md-max:w-9/12' : 'md-max:w-full', newStyle ? 'md:flex-shrink-0' : 'flex-shrink-0']"
                                :style="{ backgroundColor: item.color || '#6A503B' }">
                                <div v-if="item.quote" class="mb-7 text-base leading-5 xl:text-17 font-ww-regular">"{{
                                    item.quote }}"</div>
                                <div class="">
                                    <div class="text-base font-bold leading-6 xl:text-17 font-ww-bold">{{ item.author }}
                                    </div>
                                    <div class="mt-2 text-sm leading-4 font-ww-regular">{{ item.desc }}</div>
                                </div>
                                <!-- Tail -->
                                <div class="absolute -bottom-[33px]"
                                    :class="item.layout === 'image-left' ? 'lg:left-12 left-[50%] -translate-x-1/2 lg:translate-x-0' : 'lg:right-12 right-[50%] translate-x-1/2 lg:translate-x-0'">
                                    <svg v-if="item.layout !== 'image-left'" width="29" height="36" viewBox="0 0 29 36"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M23.4944 34.1262L0.641471 4.84581C-0.895961 2.87598 0.50763 -1.5947e-07 3.00642 -2.68696e-07L25.8594 -1.26763e-06C27.5162 -1.34005e-06 28.8594 1.34315 28.8594 3L28.8594 32.2803C28.8594 35.1343 25.2504 36.376 23.4944 34.1262Z"
                                            :fill="item.color || '#6A503B'" />
                                    </svg>
                                    <svg v-else width="29" height="36" viewBox="0 0 29 36" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5.36494 34.1262L28.2179 4.84581C29.7553 2.87598 28.3517 -1.5947e-07 25.853 -2.68696e-07L3 -1.26763e-06C1.34315 -1.34005e-06 1.73346e-06 1.34315 1.66103e-06 3L3.81148e-07 32.2803C2.56399e-07 35.1343 3.60901 36.376 5.36494 34.1262Z"
                                            :fill="item.color || '#6A503B'" />
                                    </svg>
                                </div>
                            </div>
                            <!-- Image -->
                            <div :class="[
                                item.layout === 'image-left' ? (item.overlapClass || '-mr-8') : (item.overlapClass || '-ml-8'),
                                newStyle ? 'md:flex-shrink-0' : 'flex-shrink-0'
                            ]">
                                <nuxt-img :src="item.image" :width="item.width" :height="item.height"
                                    class="-mb-8 rounded-2xl shadow-lg"
                                    :class="[item.customImgCLass, newStyle ? 'md-max:w-40' : '']" loading="lazy"
                                    format="webp" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right Column -->
                <div class="mt-6 lg:pl-8 lg:mt-0">
                    <h3 class="mb-8 font-bold text-center text-black md:mb-12 font-ww-bold lg:text-left"
                        :class="newStyle ? 'text-4xl' : 'xl:text-3xl text-2xl'" v-html="rightTitle"></h3>
                    <div class="space-y-12">
                        <div v-for="(item, index) in rightItems" :key="index"
                            class="flex relative gap-y-8 md-max:items-center" :class="[
                                item.customImgCLass ? 'center' : 'lg:!items-end',
                                item.layout === 'image-left' ? 'flex-row-reverse' : '',
                                item.align ? `items-${item.align}` : 'items-center',
                                newStyle ? '' : 'md-max:flex-col'
                            ]">
                            <!-- Text Box -->
                            <div class="relative z-10 p-6 text-white rounded-2xl shadow-lg "
                                :class="[item.textBoxWidth || 'w-[65%]', item.textBoxClass, newStyle ? 'md-max:w-9/12' : 'md-max:w-full', newStyle ? 'md:flex-shrink-0' : 'flex-shrink-0']"
                                :style="{ backgroundColor: item.color || '#8656C6' }">
                                <div v-if="item.quote" class="mb-7 text-base leading-5 xl:text-17 font-ww-regular">"{{
                                    item.quote }}"</div>
                                <div class="">
                                    <div class="text-base font-bold leading-6 xl:text-17 font-ww-bold">{{ item.author }}
                                    </div>
                                    <div class="mt-2 text-sm leading-4 font-ww-regular">{{ item.desc }}</div>
                                </div>
                                <!-- Tail -->
                                <div class="absolute -bottom-[33px]"
                                    :class="[item.layout === 'image-left' ? 'lg:left-12 left-[50%] -translate-x-1/2 lg:translate-x-0' : 'lg:right-12 right-[50%] translate-x-1/2 lg:translate-x-0', item.customImgCLass ? 'lg:right-16 lg:-top-6 lg:-mb-1 lg:rotate-180 lg:!bottom-full' : '']">
                                    <svg v-if="item.layout !== 'image-left'" width="29" height="36" viewBox="0 0 29 36"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M23.4944 34.1262L0.641471 4.84581C-0.895961 2.87598 0.50763 -1.5947e-07 3.00642 -2.68696e-07L25.8594 -1.26763e-06C27.5162 -1.34005e-06 28.8594 1.34315 28.8594 3L28.8594 32.2803C28.8594 35.1343 25.2504 36.376 23.4944 34.1262Z"
                                            :fill="item.color || '#8656C6'" />
                                    </svg>
                                    <svg v-else width="29" height="36" viewBox="0 0 29 36" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5.36494 34.1262L28.2179 4.84581C29.7553 2.87598 28.3517 -1.5947e-07 25.853 -2.68696e-07L3 -1.26763e-06C1.34315 -1.34005e-06 1.73346e-06 1.34315 1.66103e-06 3L3.81148e-07 32.2803C2.56399e-07 35.1343 3.60901 36.376 5.36494 34.1262Z"
                                            :fill="item.color || '#8656C6'" />
                                    </svg>
                                </div>
                            </div>
                            <!-- Image -->
                            <div :class="[
                                item.layout === 'image-left' ? (item.overlapClass || '-mr-8') : (item.overlapClass || '-ml-8'),
                                newStyle ? 'md:flex-shrink-0' : 'flex-shrink-0'
                            ]">
                                <nuxt-img :src="item.image" :width="item.width" :height="item.height"
                                    class="-mb-8 rounded-2xl shadow-lg"
                                    :class="[item.customImgCLass, newStyle ? 'md-max:w-40' : '']" loading="lazy"
                                    format="webp" />
                            </div>
                        </div>
                    </div>

                    <!-- Second Section (Entrepreneurs) -->
                    <div class="pt-6 mt-12 border-t border-[#CECECE] lg:pt-8 lg:mt-16">
                        <h3 class="mb-6 text-xl font-bold text-center text-black xl:text-2xl font-ww-bold lg:text-left"
                            v-html="rightTitle2">
                        </h3>
                        <div class="space-y-12">
                            <div v-for="(item, index) in rightItems2" :key="index"
                                class="flex relative lg:!items-end gap-y-8 md-max:items-center" :class="[
                                    item.layout === 'image-left' ? 'flex-row-reverse' : '',
                                    item.align ? `items-${item.align}` : 'items-center',
                                    newStyle ? '' : 'md-max:flex-col'
                                ]">
                                <!-- Text Box -->
                                <div class="relative z-10 p-6 text-white rounded-2xl shadow-lg "
                                    :class="[item.textBoxWidth || 'w-[65%]', item.textBoxClass, newStyle ? 'md-max:w-9/12' : 'md-max:w-full', newStyle ? 'md:flex-shrink-0' : 'flex-shrink-0']"
                                    :style="{ backgroundColor: item.color || '#59845B' }">
                                    <div v-if="item.quote" class="mb-7 text-base leading-5 xl:text-17 font-ww-regular">
                                        "{{ item.quote }}"</div>
                                    <div class="">
                                        <div class="text-base font-bold leading-6 xl:text-17 font-ww-bold">{{
                                            item.author }}</div>
                                        <div class="mt-2 text-sm leading-4 font-ww-regular">{{ item.desc }}</div>
                                    </div>
                                    <!-- Tail -->
                                    <div class="absolute -bottom-[33px]"
                                        :class="item.layout === 'image-left' ? 'lg:left-12 left-[50%]' : 'lg:right-12 right-[50%]'">
                                        <svg v-if="item.layout !== 'image-left'" width="29" height="36"
                                            viewBox="0 0 29 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M23.4944 34.1262L0.641471 4.84581C-0.895961 2.87598 0.50763 -1.5947e-07 3.00642 -2.68696e-07L25.8594 -1.26763e-06C27.5162 -1.34005e-06 28.8594 1.34315 28.8594 3L28.8594 32.2803C28.8594 35.1343 25.2504 36.376 23.4944 34.1262Z"
                                                :fill="item.color || '#59845B'" />
                                        </svg>
                                        <svg v-else width="29" height="36" viewBox="0 0 29 36" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M5.36494 34.1262L28.2179 4.84581C29.7553 2.87598 28.3517 -1.5947e-07 25.853 -2.68696e-07L3 -1.26763e-06C1.34315 -1.34005e-06 1.73346e-06 1.34315 1.66103e-06 3L3.81148e-07 32.2803C2.56399e-07 35.1343 3.60901 36.376 5.36494 34.1262Z"
                                                :fill="item.color || '#59845B'" />
                                        </svg>
                                    </div>
                                </div>
                                <!-- Image -->
                                <div :class="[
                                    item.layout === 'image-left' ? (item.overlapClass || '-mr-8') : (item.overlapClass || '-ml-8'),
                                    newStyle ? 'md:flex-shrink-0' : 'flex-shrink-0'
                                ]">
                                    <nuxt-img :src="item.image" :width="item.width" :height="item.height"
                                        class="-mb-8 rounded-2xl shadow-lg"
                                        :class="[item.customImgCLass, newStyle ? 'md-max:w-40' : '']" loading="lazy"
                                        format="webp" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    newStyle: {
        type: Boolean,
        default: false
    },
    leftTitle: {
        type: String,
        default: 'Doctors LOVE Lifeboost!'
    },
    rightTitle: {
        type: String,
        default: 'Health & Fitness Professionals LOVE Lifeboost!'
    },
    rightTitle2: {
        type: String,
        default: 'Entrepreneurs and Businesses LOVE Lifeboost!'
    },
    leftItems: {
        type: Array,
        default: () => [
            {
                quote: 'I love this coffee not only for its great taste but also because it is pure, toxin free and actually good for you.',
                author: 'Peter Jakacki, DC, MD',
                desc: 'Dr Jakacki is a licensed medical doctor who is also a board certified chiropractic physician with specialties in family medicine and functional medicine',
                image: '/assets/images/dr-bogo-1.jpg',
                layout: 'text-left',
                color: '#6A503B',
                width: 187,
                height: 261
            },
            {
                quote: 'Single origin, organic, low acidic and pure Lifeboost Coffee is one of the most delightful taste buds pleaser you will ever find in your life. Try it black or with a little bit of organic cinnamon, coconut oil, and honey... mmm. Lifeboost Coffee is the best choice for me and my family, and we recommend it to everyone around us. Cheers!',
                author: 'Gencho Ivanov, LMT, MAT',
                desc: 'Martial Arts Enthusiast',
                image: '/assets/images/dr-bogo-2.jpg',
                layout: 'image-left',
                color: '#6A503B',
                width: 187,
                height: 339
            },
            {
                quote: 'Lifeboost Coffee is my favorite! It\'s extremely low acid and easy on the stomach. It gets my 5 star recommendation.',
                author: 'Dr Aaron Oxenrider',
                desc: 'Board Certified Chiropractic Physician and Regenerative Medicine Expert',
                image: '/assets/images/dr-bogo-3.jpg',
                layout: 'text-left',
                color: '#6A503B',
                width: 187,
                height: 223
            },
            {
                quote: 'Best tasting organic low acid coffee ever! And it\'s great on your teeth!',
                author: 'Dr. Gary Sanchez',
                desc: 'Board Certified Dentist',
                image: '/assets/images/dr-bogo-4.jpg',
                layout: 'image-left',
                color: '#6A503B',
                width: 187,
                height: 223
            },
            {
                quote: '',
                author: 'Dr. Chad Walding ',
                desc: 'Doctor of Physical Therapy (DPT), SFMA, RKC II, OPEX L1, Owner Lexicon Health',
                image: '/assets/images/dr-bogo-5.jpg',
                layout: 'image-right',
                color: '#6A503B',
                width: 187,
                height: 146
            },
            {
                quote: 'Lifeboost Coffee is one of the healthiest, smoothest coffee\'s I\'ve ever had. The ultra low acidity makes it perfect for those with stomach issues and digestive problems. Couple that with the rich, full bodied flavor and it\'s a treat I look forward to every day.',
                author: 'Joseph R. Feste, M.D., FACOG, AACS, AACG, Natural Bio Health Hormones & Weight Loss.',
                desc: 'Member of the American Society of Bariatric Physicians. He has extensive experience in the fields of obstetrics and gynecology.',
                image: '/assets/images/dr-bogo-6.jpg',
                layout: 'image-left',
                color: '#6A503B',
                width: 193,
                height: 489
            },
            {
                quote: 'Wow. Having studied health and anti-aging for years as well as owning several anti-aging medical clinics, I\'m well aware of the health research behind a good cup of coffee. After tasting Lifeboost, I was WOW\'ed by the difference. Most organic coffees don\'t taste that good! They seem bland in comparison. The ultra low acidity is definitely a PLUS as well. Keep up the good work!',
                author: 'Mike Clark, MBA, JD, PHD, ABHRT, FAARM',
                desc: 'Doctorate in Natural Medicine, Health Practitioner Diplomate in the Clinical Science of Anti-Aging. Fellow and Advanced Fellow of Anti-Aging, Regenerative & Functional Medicine.',
                image: '/assets/images/dr-bogo-7.jpg',
                layout: 'text-left',
                color: '#6A503B',
                width: 158,
                height: 406
            },
            {
                quote: 'I never drank coffee in my life until I started my medical residency as an older adult, while being married, and raising three teenagers. I found quickly I loved coffee that is smooth and does not create jitters or bother my stomach. LifeBoost coffee has risen above all my expectations! Love it!!!',
                author: 'Ryan Bentley, MD, PhD, DC',
                desc: 'Dr Bentley is a licensed medical doctor, and board certified chiropractic physician who specializes in functional medicine.',
                image: '/assets/images/dr-bogo-8.jpg',
                layout: 'image-left',
                color: '#6A503B',
                width: 193,
                height: 396
            }
        ]
    },
    rightItems: {
        type: Array,
        default: () => [
            {
                quote: 'My favorite way to start the day and I love knowing it\'s fair trade organic! I\'m super picky about coffee and this is the perfect bold flavor but not bitter. The smell is amazing too! Thanks, Lifeboost!',
                author: 'Erin Nielsen, PT, CHC',
                desc: 'theyouthmethod.com',
                image: '/assets/images/bogo-professional-1.jpg',
                layout: 'text-left',
                color: '#8656C6',
                width: 194,
                height: 228
            },
            {
                quote: 'Lifeboost is by far the smoothest, most delicious coffee I\'ve ever tasted. Whether I\'m using intermittent fasting or just need a burst of energy and focus for my intense work load, Lifeboost delivers the cleanest, purest coffee energy you can find. I look forward to my daily cup (or two) each day to help boost my immune health and increase my productivity.',
                author: 'Shaun Hadsall',
                desc: 'Owner of GetLeanAfter40',
                image: '/assets/images/bogo-professional-2.jpg',
                layout: 'image-left',
                color: '#8656C6',
                width: 399,
                height: 313,
                align: 'start',
                customImgCLass: 'relative lg:left-24',
                textBoxWidth: 'w-[85%]',
                overlapClass: 'lg:-mr-48 lg:-mr-80',
                textBoxClass: 'lg:mt-40 mt-8'
            },
            {
                quote: '',
                author: 'Julia Lundstrom',
                desc: 'Neuroscience and Brain Health Educator, Simple Smart Science',
                image: '/assets/images/bogo-professional-3.jpg',
                layout: 'text-left',
                color: '#8656C6',
                width: 194,
                height: 121
            },
            {
                quote: 'Wow! This coffee is incredible! Super smooth and the lowest acid coffee I\'ve ever drank. It doesn\'t hurt my stomach at all! Careful though, it goes down really fast! It\'s my perfect way to start out my morning with a cool smooth burst of energy. Thanks Dr Charles!',
                author: 'John Rowley',
                desc: 'America\'s Lifestyle Strategist, Best Selling Author and Speaker',
                image: '/assets/images/bogo-professional-4.jpg',
                layout: 'image-left',
                color: '#8656C6',
                width: 194,
                height: 309
            },
            {
                quote: 'No more tummy upset delaying getting out the door on time. Love the mildness yet still great taste.',
                author: 'Teresa Davis, PT',
                desc: 'Independent Consultant',
                image: '/assets/images/bogo-professional-5.jpg',
                layout: 'image-left',
                color: '#8656C6',
                width: 194,
                height: 204
            }
        ]
    },
    rightItems2: {
        type: Array,
        default: () => [
            {
                quote: 'This is the only coffee I drink at home and almost always never travel without!',
                author: 'Matt Clark',
                desc: 'Entrepreneur, Investor, Chairman of Amazing.com, Inc.',
                image: '/assets/images/bogo-professional-6.jpg',
                layout: 'image-left',
                color: '#59845B',
                width: 194,
                height: 211
            },
            {
                quote: '',
                author: 'Dan Long',
                desc: 'Entrepreneur and Co-host of Born To Impact Podcast',
                image: '/assets/images/bogo-professional-7.jpg',
                layout: 'text-left',
                color: '#59845B',
                width: 176,
                height: 129
            },
            {
                quote: '',
                author: 'Chad Tackett',
                desc: 'Founder of Fitera',
                image: '/assets/images/bogo-professional-8.jpg',
                layout: 'image-left',
                color: '#59845B',
                width: 176,
                height: 110
            },
            {
                quote: 'Frankly one of the only coffees I can drink with my GI issues, Tastes Amazing!',
                author: 'James Guldan',
                desc: 'Entrepreneur, Founder and CEO of Vision Tech Team',
                image: '/assets/images/bogo-professional-9.jpg',
                layout: 'image-left',
                color: '#59845B',
                width: 176,
                height: 211
            },
            {
                quote: '',
                author: 'Ed O\' Keefe',
                desc: 'CEO of EOK Marketing Group',
                image: '/assets/images/bogo-professional-10.jpg',
                layout: 'image-left',
                color: '#59845B',
                width: 176,
                height: 113
            }
        ]
    }
});

defineBuilderComponent({
    friendlyName: 'Split Images With Text',
    inputs: [
        {
            name: 'newStyle',
            type: 'boolean',
            friendlyName: 'New Style',
            defaultValue: false
        },
        {
            name: 'leftTitle',
            type: 'html',
            defaultValue: 'Doctors LOVE Lifeboost!',
            friendlyName: 'Left Column Title'
        },
        {
            name: 'rightTitle',
            type: 'html',
            defaultValue: 'Health & Fitness Professionals LOVE Lifeboost!',
            friendlyName: 'Right Column Title'
        },
        {
            name: 'rightTitle2',
            type: 'html',
            defaultValue: 'Entrepreneurs and Businesses LOVE Lifeboost!',
            friendlyName: 'Right Column Second Title'
        },
        {
            name: 'leftItems',
            type: 'list',
            friendlyName: 'Left Column Testimonials',
            defaultValue: [
                {
                    quote: 'I love this coffee not only for its great taste but also because it is pure, toxin free and actually good for you.',
                    author: 'Peter Jakacki, DC, MD',
                    desc: 'Dr Jakacki is a licensed medical doctor who is also a board certified chiropractic physician with specialties in family medicine and functional medicine',
                    image: '/assets/images/dr-bogo-1.jpg',
                    layout: 'text-left',
                    color: '#6A503B',
                    width: 187,
                    height: 261
                },
                {
                    quote: 'Single origin, organic, low acidic and pure Lifeboost Coffee is one of the most delightful taste buds pleaser you will ever find in your life. Try it black or with a little bit of organic cinnamon, coconut oil, and honey... mmm. Lifeboost Coffee is the best choice for me and my family, and we recommend it to everyone around us. Cheers!',
                    author: 'Gencho Ivanov, LMT, MAT',
                    desc: 'Martial Arts Enthusiast',
                    image: '/assets/images/dr-bogo-2.jpg',
                    layout: 'image-left',
                    color: '#6A503B',
                    width: 187,
                    height: 339
                },
                {
                    quote: 'Lifeboost Coffee is my favorite! It\'s extremely low acid and easy on the stomach. It gets my 5 star recommendation.',
                    author: 'Dr Aaron Oxenrider',
                    desc: 'Board Certified Chiropractic Physician and Regenerative Medicine Expert',
                    image: '/assets/images/dr-bogo-3.jpg',
                    layout: 'text-left',
                    color: '#6A503B',
                    width: 187,
                    height: 223
                },
                {
                    quote: 'Best tasting organic low acid coffee ever! And it\'s great on your teeth!',
                    author: 'Dr. Gary Sanchez',
                    desc: 'Board Certified Dentist',
                    image: '/assets/images/dr-bogo-4.jpg',
                    layout: 'image-left',
                    color: '#6A503B',
                    width: 187,
                    height: 223
                },
                {
                    quote: '',
                    author: 'Dr. Chad Walding ',
                    desc: 'Doctor of Physical Therapy (DPT), SFMA, RKC II, OPEX L1, Owner Lexicon Health',
                    image: '/assets/images/dr-bogo-5.jpg',
                    layout: 'image-right',
                    color: '#6A503B',
                    width: 187,
                    height: 146
                },
                {
                    quote: 'Lifeboost Coffee is one of the healthiest, smoothest coffee\'s I\'ve ever had. The ultra low acidity makes it perfect for those with stomach issues and digestive problems. Couple that with the rich, full bodied flavor and it\'s a treat I look forward to every day.',
                    author: 'Joseph R. Feste, M.D., FACOG, AACS, AACG, Natural Bio Health Hormones & Weight Loss.',
                    desc: 'Member of the American Society of Bariatric Physicians. He has extensive experience in the fields of obstetrics and gynecology.',
                    image: '/assets/images/dr-bogo-6.jpg',
                    layout: 'image-left',
                    color: '#6A503B',
                    width: 193,
                    height: 489
                },
                {
                    quote: 'Wow. Having studied health and anti-aging for years as well as owning several anti-aging medical clinics, I\'m well aware of the health research behind a good cup of coffee. After tasting Lifeboost, I was WOW\'ed by the difference. Most organic coffees don\'t taste that good! They seem bland in comparison. The ultra low acidity is definitely a PLUS as well. Keep up the good work!',
                    author: 'Mike Clark, MBA, JD, PHD, ABHRT, FAARM',
                    desc: 'Doctorate in Natural Medicine, Health Practitioner Diplomate in the Clinical Science of Anti-Aging. Fellow and Advanced Fellow of Anti-Aging, Regenerative & Functional Medicine.',
                    image: '/assets/images/dr-bogo-7.jpg',
                    layout: 'text-left',
                    color: '#6A503B',
                    width: 158,
                    height: 406
                },
                {
                    quote: 'I never drank coffee in my life until I started my medical residency as an older adult, while being married, and raising three teenagers. I found quickly I loved coffee that is smooth and does not create jitters or bother my stomach. LifeBoost coffee has risen above all my expectations! Love it!!!',
                    author: 'Ryan Bentley, MD, PhD, DC',
                    desc: 'Dr Bentley is a licensed medical doctor, and board certified chiropractic physician who specializes in functional medicine.',
                    image: '/assets/images/dr-bogo-8.jpg',
                    layout: 'image-left',
                    color: '#6A503B',
                    width: 193,
                    height: 396
                }
            ],
            subFields: [
                { name: 'quote', type: 'longText', friendlyName: 'Quote' },
                { name: 'author', type: 'text', friendlyName: 'Author Name' },
                { name: 'desc', type: 'text', friendlyName: 'Author Description' },
                { name: 'image', type: 'file', allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'], friendlyName: 'Author Image' },
                { name: 'layout', type: 'text', enum: ['text-left', 'image-left'], friendlyName: 'Layout (text-left or image-left)' },
                { name: 'color', type: 'color', friendlyName: 'Background Color' },
                { name: 'width', type: 'number', friendlyName: 'Image Width' },
                { name: 'height', type: 'number', friendlyName: 'Image Height' },
                { name: 'align', type: 'text', enum: ['start', 'center', 'end'], friendlyName: 'Vertical Align', defaultValue: 'center' },
                { name: 'textBoxWidth', type: 'text', friendlyName: 'Text Box Width (e.g. w-[65%])' },
                { name: 'overlapClass', type: 'text', friendlyName: 'Overlap Class (e.g. -mr-8)' },
                { name: 'textBoxClass', type: 'text', friendlyName: 'Text Box Custom Class' }
            ]
        },
        {
            name: 'rightItems',
            type: 'list',
            friendlyName: 'Right Column Testimonials (Group 1)',
            defaultValue: [
                {
                    quote: 'My favorite way to start the day and I love knowing it\'s fair trade organic! I\'m super picky about coffee and this is the perfect bold flavor but not bitter. The smell is amazing too! Thanks, Lifeboost!',
                    author: 'Erin Nielsen, PT, CHC',
                    desc: 'theyouthmethod.com',
                    image: '/assets/images/bogo-professional-1.jpg',
                    layout: 'text-left',
                    color: '#8656C6',
                    width: 194,
                    height: 228
                },
                {
                    quote: 'Lifeboost is by far the smoothest, most delicious coffee I\'ve ever tasted. Whether I\'m using intermittent fasting or just need a burst of energy and focus for my intense work load, Lifeboost delivers the cleanest, purest coffee energy you can find. I look forward to my daily cup (or two) each day to help boost my immune health and increase my productivity.',
                    author: 'Shaun Hadsall',
                    desc: 'Owner of GetLeanAfter40',
                    image: '/assets/images/bogo-professional-2.jpg',
                    layout: 'image-left',
                    color: '#8656C6',
                    width: 399,
                    height: 313,
                    align: 'start',
                    customImgCLass: 'relative lg:left-24',
                    textBoxWidth: 'w-[85%]',
                    overlapClass: 'lg:-mr-48 lg:-mr-60',
                    textBoxClass: 'lg:mt-40 mt-8'
                },
                {
                    quote: '',
                    author: 'Julia Lundstrom',
                    desc: 'Neuroscience and Brain Health Educator, Simple Smart Science',
                    image: '/assets/images/bogo-professional-3.jpg',
                    layout: 'text-left',
                    color: '#8656C6',
                    width: 194,
                    height: 121
                },
                {
                    quote: 'Wow! This coffee is incredible! Super smooth and the lowest acid coffee I\'ve ever drank. It doesn\'t hurt my stomach at all! Careful though, it goes down really fast! It\'s my perfect way to start out my morning with a cool smooth burst of energy. Thanks Dr Charles!',
                    author: 'John Rowley',
                    desc: 'America\'s Lifestyle Strategist, Best Selling Author and Speaker',
                    image: '/assets/images/bogo-professional-4.jpg',
                    layout: 'image-left',
                    color: '#8656C6',
                    width: 194,
                    height: 309
                },
                {
                    quote: 'No more tummy upset delaying getting out the door on time. Love the mildness yet still great taste.',
                    author: 'Teresa Davis, PT',
                    desc: 'Independent Consultant',
                    image: '/assets/images/bogo-professional-5.jpg',
                    layout: 'image-left',
                    color: '#8656C6',
                    width: 194,
                    height: 204
                }
            ],
            subFields: [
                { name: 'quote', type: 'longText', friendlyName: 'Quote' },
                { name: 'author', type: 'text', friendlyName: 'Author Name' },
                { name: 'desc', type: 'text', friendlyName: 'Author Description' },
                { name: 'image', type: 'file', allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'], friendlyName: 'Author Image' },
                { name: 'layout', type: 'text', enum: ['text-left', 'image-left'], friendlyName: 'Layout (text-left or image-left)' },
                { name: 'color', type: 'color', friendlyName: 'Background Color' },
                { name: 'width', type: 'number', friendlyName: 'Image Width' },
                { name: 'height', type: 'number', friendlyName: 'Image Height' },
                { name: 'align', type: 'text', enum: ['start', 'center', 'end'], friendlyName: 'Vertical Align', defaultValue: 'center' },
                { name: 'textBoxWidth', type: 'text', friendlyName: 'Text Box Width (e.g. w-[65%])' },
                { name: 'overlapClass', type: 'text', friendlyName: 'Overlap Class (e.g. -mr-8)' },
                { name: 'textBoxClass', type: 'text', friendlyName: 'Text Box Custom Class' }
            ]
        },
        {
            name: 'rightItems2',
            type: 'list',
            friendlyName: 'Right Column Testimonials (Group 2)',
            defaultValue: [
                {
                    quote: 'This is the only coffee I drink at home and almost always never travel without!',
                    author: 'Matt Clark',
                    desc: 'Entrepreneur, Investor, Chairman of Amazing.com, Inc.',
                    image: '/assets/images/bogo-professional-6.jpg',
                    layout: 'image-left',
                    color: '#59845B',
                    width: 194,
                    height: 211
                },
                {
                    quote: '',
                    author: 'Dan Long',
                    desc: 'Entrepreneur and Co-host of Born To Impact Podcast',
                    image: '/assets/images/bogo-professional-7.jpg',
                    layout: 'text-left',
                    color: '#59845B',
                    width: 176,
                    height: 129
                },
                {
                    quote: '',
                    author: 'Chad Tackett',
                    desc: 'Founder of Fitera',
                    image: '/assets/images/bogo-professional-8.jpg',
                    layout: 'image-left',
                    color: '#59845B',
                    width: 176,
                    height: 110
                },
                {
                    quote: 'Frankly one of the only coffees I can drink with my GI issues, Tastes Amazing!',
                    author: 'James Guldan',
                    desc: 'Entrepreneur, Founder and CEO of Vision Tech Team',
                    image: '/assets/images/bogo-professional-9.jpg',
                    layout: 'image-left',
                    color: '#59845B',
                    width: 176,
                    height: 211
                },
                {
                    quote: '',
                    author: 'Ed O\' Keefe',
                    desc: 'CEO of EOK Marketing Group',
                    image: '/assets/images/bogo-professional-10.jpg',
                    layout: 'image-left',
                    color: '#59845B',
                    width: 176,
                    height: 113
                }
            ],
            subFields: [
                { name: 'quote', type: 'longText', friendlyName: 'Quote' },
                { name: 'author', type: 'text', friendlyName: 'Author Name' },
                { name: 'desc', type: 'text', friendlyName: 'Author Description' },
                { name: 'image', type: 'file', allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'], friendlyName: 'Author Image' },
                { name: 'layout', type: 'text', enum: ['text-left', 'image-left'], friendlyName: 'Layout (text-left or image-left)' },
                { name: 'color', type: 'color', friendlyName: 'Background Color' },
                { name: 'width', type: 'number', friendlyName: 'Image Width' },
                { name: 'height', type: 'number', friendlyName: 'Image Height' },
                { name: 'align', type: 'text', enum: ['start', 'center', 'end'], friendlyName: 'Vertical Align', defaultValue: 'center' },
                { name: 'textBoxWidth', type: 'text', friendlyName: 'Text Box Width (e.g. w-[65%])' },
                { name: 'overlapClass', type: 'text', friendlyName: 'Overlap Class (e.g. -mr-8)' },
                { name: 'textBoxClass', type: 'text', friendlyName: 'Text Box Custom Class' }
            ]
        }
    ]
});
</script>
